import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, Fragment } from "react";
import PropTypes from "prop-types";
import { flattenChildren } from "../../utils/flatten-children.es.js";
import { Separator } from "../separator/separator.es.js";
import { InlineItem } from "./inline-item.es.js";
import { InlineImpl } from "./inline.styles.es.js";
const propTypes = {
  alignY: PropTypes.oneOf(["bottom", "center", "stretch", "top"]),
  children: PropTypes.node,
  heightMode: PropTypes.oneOf(["fill-container", "fit-content"]),
  separators: PropTypes.bool,
  space: PropTypes.oneOf(["none", "xsmall", "small", "medium", "large"])
};
const defaultProps = {
  alignY: "center",
  children: void 0,
  heightMode: "fit-content",
  separators: false,
  space: "medium"
};
const Inline = forwardRef(
  ({ alignY, children, heightMode, separators, space }, forwardedRef) => /* @__PURE__ */ jsx(
    InlineImpl,
    {
      ref: forwardedRef,
      $alignY: alignY,
      $heightMode: heightMode,
      $space: space,
      children: flattenChildren(children).map((child, index) => {
        if (!!child && child.type !== InlineItem && child.type !== Separator) {
          console.warn(
            "Inline: The use of InlineItem is required. Wrap each direct child with an InlineItem."
          );
        }
        return /* @__PURE__ */ jsxs(Fragment, { children: [
          separators === true && index > 0 && /* @__PURE__ */ jsx(Separator, {}),
          child
        ] }, child.key);
      })
    }
  )
);
Inline.propTypes = propTypes;
Inline.defaultProps = defaultProps;
export {
  Inline
};
